$(function () {
    // 戻るのチェックボックス復帰処理
    $(".checkbox input:checkbox:checked").each(function (index, item) {
        // inputがチェックされていたら、ラベルもチェック状態にする
        $(item).closest(".checkbox").addClass("checked");
    });

    // ラベル不要なチェックボックスのため、自作
    $(".checkbox").click(function (e) {
        // 自身のクリックのみ（子要素に伝播されたイベントは処理しない）
        if (e.target === e.currentTarget) {
            $(this).toggleClass("checked");
        }
    });

    // 部屋一覧の表示／非表示
    $(".room-list .more").click(function (e) {
        $this = $(this);
        if ($this.hasClass("on")) {
            // moreが開いているとき
            $(".room-list .room-hide").hide();
            $(".room-list .more p").text("物件情報をすべて表示する");
            $(this).removeClass("on");
        } else {
            $(".room-list .room-hide").show();
            $(".room-list .more p").text("物件情報を一部非表示にする");
            $(this).addClass("on");
        }
    });
});
